import urlWithParams from 'utils/urlWithParams';
import {apiV2} from '../api';
import CallerTeamComboboxSearchFieldActions from 'actions/search/CallerTeamComboboxSearchFieldActions';

const CallerTeamComboboxSearchFieldSource = {
  searchTeams: {
    remote(state, searchTerm) {
      const queryArgs = {q: encodeURIComponent(searchTerm)};
      return apiV2.get(urlWithParams('/teams/autocomplete', queryArgs));
    },
    loading: CallerTeamComboboxSearchFieldActions.searchTeamsLoading,
    success: CallerTeamComboboxSearchFieldActions.searchTeamsSuccess,
    error: CallerTeamComboboxSearchFieldActions.searchTeamsError,
  },

  searchReps: {
    remote(state, searchTerm) {
      const queryArgs = {q: encodeURIComponent(searchTerm)};
      return apiV2.get(urlWithParams('/users/autocomplete', queryArgs));
    },
    loading: CallerTeamComboboxSearchFieldActions.searchRepsLoading,
    success: CallerTeamComboboxSearchFieldActions.searchRepsSuccess,
    error: CallerTeamComboboxSearchFieldActions.searchRepsError,
  },

  searchManagers: {
    remote(state, searchTerm) {
      const queryArgs = {q: encodeURIComponent(searchTerm), is_manager: true};
      return apiV2.get(urlWithParams('/users/autocomplete', queryArgs));
    },
    loading: CallerTeamComboboxSearchFieldActions.searchManagersLoading,
    success: CallerTeamComboboxSearchFieldActions.searchManagersSuccess,
    error: CallerTeamComboboxSearchFieldActions.searchManagersError,
  },

  fetchUserList: {
    remote(state, repIds) {
      const queryArgs = {users: encodeURIComponent(repIds)};
      return apiV2.get(urlWithParams('/users/list', queryArgs));
    },
    loading: CallerTeamComboboxSearchFieldActions.fetchSelectedRepsLoading,
    success: CallerTeamComboboxSearchFieldActions.fetchSelectedRepsSuccess,
    error: CallerTeamComboboxSearchFieldActions.fetchSelectedRepsError,
  },

  fetchManagerList: {
    remote(state, managerIds) {
      const queryArgs = {
        users: encodeURIComponent(managerIds),
        is_manager: true,
      };
      return apiV2.get(urlWithParams('/users/list', queryArgs));
    },
    loading: CallerTeamComboboxSearchFieldActions.fetchSelectedManagersLoading,
    success: CallerTeamComboboxSearchFieldActions.fetchSelectedManagersSuccess,
    error: CallerTeamComboboxSearchFieldActions.fetchSelectedManagersError,
  },

  fetchTeamList: {
    remote(state, teamIds) {
      const queryArgs = {teams: encodeURIComponent(teamIds)};
      return apiV2.get(urlWithParams('/teams/list', queryArgs));
    },
    loading: CallerTeamComboboxSearchFieldActions.fetchSelectedTeamsLoading,
    success: CallerTeamComboboxSearchFieldActions.fetchSelectedTeamsSuccess,
    error: CallerTeamComboboxSearchFieldActions.fetchSelectedTeamsError,
  },
};

export default CallerTeamComboboxSearchFieldSource;
